import {
    EducationJobQualification,
    SkillJobQualification,
    LicenseJobQualification,
    LicenseAnyOfJobQualification,
    CustomYesNoJobQualification,
    CustomTextJobQualification
} from "../../domain";
import * as React from "react";

import { baseColors, RelodeTheme, Text } from "../..";

import { createStyles, makeStyles } from "@material-ui/core";
import {
    CustomTextQualificationView,
    CustomYesNoQualificationView,
    EducationJobQualificationView,
    LicenseJobQualificationView,
    SkillJobQualificationView
} from "./jobQualificationViewTypes";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            paper: {
                padding: theme.spacing(2),
            },
            noPadding: {
                padding: theme.spacing(0),
                [theme.breakpoints.down("md")]: {
                    padding: theme.spacing(2),
                },
            },
            list: {
                display: "flex",
                flexDirection: "column",
                gap: theme.spacing(0.5),
                marginBottom: theme.spacing(3),
            },
            listItem: {
                padding: theme.spacing(0, 4, 0, 4),
                display: "flex",
                flexDirection: "column",
                gap: theme.spacing(0.5),
                margin: "0px",
                listStyle: "disc",
            },
            header: {
                marginBottom: 15,
            },
            preparingContainer: {
                padding: theme.spacing(3.5, 0),
                backgroundColor: baseColors.cool_gray,
                border: "1px solid",
                borderColor: baseColors.warm_gray,
                width: "220px",
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                alignItems: "center",
                textAlign: "center",
                color: baseColors.light_black,
            },
            preparingWait: {
                display: "flex",
                alignItems: "center",
                gap: "4px",
            }
        }),
    { name: "QualificationView" }
);

export const JobQualificationsList = (props: {
    title: string;
    jobQualifications: {
        educationJobQualifications: EducationJobQualification[];
        skillJobQualifications: SkillJobQualification[];
        skillAnyOfJobQualifications: SkillJobQualification[];
        licenseJobQualifications: LicenseJobQualification[];
        licenseAnyOfJobQualifications: LicenseAnyOfJobQualification[];
        customYesNoJobQualifications: CustomYesNoJobQualification[];
        customTextJobQualifications: CustomTextJobQualification[];
    };
}) => {
    const { jobQualifications, title } = props;
    const classes = useStyles({});

    return (
        <div className={classes.list}>
            <Text variant="subtitle2">{title}</Text>
            {jobQualifications.educationJobQualifications.length > 0 && (
                <ul className={classes.listItem}>
                    <EducationJobQualificationView
                        qual={jobQualifications.educationJobQualifications[0]}
                    />
                </ul>
            )}

            {jobQualifications.skillJobQualifications.length > 0 && (
                <ul className={classes.listItem}>
                    {jobQualifications.skillJobQualifications.map(s => (
                        <SkillJobQualificationView
                            key={s.id}
                            qual={s}
                            isAnyOf={false}
                        />
                    ))}
                </ul>
            )}

            {jobQualifications.skillAnyOfJobQualifications.length > 0 && (
                <ul className={classes.listItem}>
                    {jobQualifications.skillAnyOfJobQualifications.map(s => (
                        <SkillJobQualificationView
                            key={s.id}
                            qual={s}
                            isAnyOf={true}
                        />
                    ))}
                </ul>
            )}

            {jobQualifications.licenseJobQualifications.length > 0 && (
                <ul className={classes.listItem}>
                    {jobQualifications.licenseJobQualifications.map(l => (
                        <LicenseJobQualificationView
                            key={l.id}
                            qual={l}
                            isAnyOf={false}
                        />
                    ))}
                </ul>
            )}

            {jobQualifications.licenseAnyOfJobQualifications.length > 0 && (
                <ul className={classes.listItem}>
                    {jobQualifications.licenseAnyOfJobQualifications.map(l => (
                        <LicenseJobQualificationView
                            key={l.id}
                            qual={l}
                            isAnyOf={true}
                        />
                    ))}
                </ul>
            )}

            {jobQualifications.customYesNoJobQualifications.length > 0 && (
                <ul className={classes.listItem}>
                    {jobQualifications.customYesNoJobQualifications.map(c => (
                        <CustomYesNoQualificationView key={c.id} qual={c} />
                    ))}
                </ul>
            )}

            {jobQualifications.customTextJobQualifications.length > 0 && (
                <ul className={classes.listItem}>
                    {jobQualifications.customTextJobQualifications.map(c => (
                        <CustomTextQualificationView key={c.id} qual={c} />
                    ))}
                </ul>
            )}
        </div>
    );
};
